import { combineReducers } from 'redux';

import { annotations } from './annotations';
import { artistOverview } from './artistOverview';
import { timeline } from './timeline';

export const audience = combineReducers({
  annotations,
  artistOverview,
  timeline,
});
